export default "__VITE_ASSET__WGrQdxzc__"